enum Vendor {
    Medicover = 1,
    Cmd = 2,
    MediPartner = 3,
    Network = 4,
    Medvit = 5,
    DentaCare = 6,
    RankingLekarzy = 7,
    ZnanyLekarz = 8,
    MMedicaClinic = 9,
    Rehasport = 10
}

export default Vendor;